function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveLoansIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 3.20312L3.70084 12.8031",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 12.7969L3.70084 3.19693",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveLoansIcons);
export default __webpack_public_path__ + "static/media/removeLoansIcons.efa290b19b33768347c379a71eb97cd6.svg";
export { ForwardRef as ReactComponent };